import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router keeps the browser's current scroll position across client-side
// navigations (there's no full page load to reset it) - without this, following
// a link while scrolled down (e.g. a Footer link, clicked from the bottom of a
// long page) lands on the new page still scrolled down instead of at its top.
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
